import { InlinePlanSelector } from "@/components/billing/inline-plan-selector";

import type { PricingTier } from "./checkout-types";

// Legacy source: src/components/billing/checkout/checkout-step-plan.tsx (1:1 port).
// Legacy imported PricingTier from "@/components/pricing/pricing-section";
// in the SPA the type lives in "./checkout-types".

interface StepPlanProps {
  defaultCategory?: string;
  onSelectPlan: (
    planCode: string,
    planName: string,
    entityType: string,
    planData: PricingTier,
    interval: "monthly" | "annual",
  ) => void;
}

export function CheckoutStepPlan({ defaultCategory, onSelectPlan }: StepPlanProps) {
  return (
    <div className="p-5">
      <InlinePlanSelector defaultCategory={defaultCategory} compact onSelectPlan={onSelectPlan} />
    </div>
  );
}
